import { SEARCH_ORDER_MAPPING, TQueryParams } from 'lib/search'
import { searchOrdering } from '../events'
import Select from 'components/form/Select'
import styles from '../Search.module.scss'

type TProps = {
  value?: string | undefined
  queryVariables: TQueryParams
  onChange: (query: TQueryParams) => void
}
const OrderBy = ({ value, queryVariables, onChange }: TProps) => (
  <div className={styles.ecSearchOrderBy}>
    <Select
      selectElementProps={{
        value,
        onChange: (e) => {
          const newQueryVariables = {
            ...queryVariables,
            orderBy: e.target.value,
            ...{ pagination: 1 },
          }
          const orderProps = SEARCH_ORDER_MAPPING.find(
            (item) => item.optionValue === e.target.value,
          ) || { orderBy: { field: null, type: null } }
          searchOrdering({ ...orderProps?.orderBy })

          onChange(newQueryVariables)
        },
      }}
    >
      <option value="">Relevância</option>
      {SEARCH_ORDER_MAPPING.map((item, index) => {
        const orderOptionKey = `orderByButton${index}`
        return (
          <option key={orderOptionKey} value={item.optionValue}>
            {item.optionLabel}
          </option>
        )
      })}
    </Select>
  </div>
)

export default OrderBy
